
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/tree-view/tree-item",
      function () {
        return require("private-next-pages/x/api/tree-view/tree-item.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/tree-view/tree-item"])
      });
    }
  